import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useCallback, useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import { colors, Grid, Button } from '@mui/material';
import { Page, Header } from 'components';

import WeeklyReportTable from './components/WeeklyReportTable';

import { GetWeeklyReportTable, GenerateWeeklyReport } from '../actions/WeeklyReportActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	generate_weekly: {
		marginTop: theme.spacing(3),
		color: theme.palette.white,
		backgroundColor: '#039be5',
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const WeeklyReport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const weeklyReportTable = useSelector((state) => state.weeklyReportReducer.weeklyReportTable);

	useEffect(() => {
		dispatch(GetWeeklyReportTable());
	}, []);

	const _generateWeekly = () => {
		dispatch(GenerateWeeklyReport());
	};

	return (
		<Page className={classes.root} title="Weekly Report Table">
			<Header module="Weekly Report Table" view="Weekly Report Table" />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<WeeklyReportTable className={classes.results} data={weeklyReportTable} />
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item md={4} xs={4}>
					<Button className={classes.generate_weekly} onClick={_generateWeekly} variant="contained">Download Weekly Report</Button>
				</Grid>
			</Grid>
		</Page>
	);
};

export default WeeklyReport;
